<template>
  <div>
    <div class="modal fade" id="coverLevelDiscount" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title ml-4 float-left font-weight-bold">Cover Level Discount</h5>
            <button  id="cover_level_disc_renew" type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="border-divison ml-3">
            <div class="style-border mt-1"/>
          </div>
          <div class="modal-body mt-1 pb-0">
            <div class="col-12 row pt-2 pb-2">
              <div class="col-8 float-left px-0 py-2">Depreciation Shield</div>
              <div class="col-4 float-right">
                <float-label>
                  <input type="text" class="style-box">
                </float-label>
              </div>
            </div>
            <div class="col-12 row bg-color pt-2 pb-2">
              <div class="col-8 float-left px-0 py-2">
                <p>24x7 Road Side Assistance</p>
              </div>
              <div class="col-4 float-right">
                <float-label>
                  <input type="text" class="style-box">
                </float-label>
              </div>
            </div>
            <div class="col-12 row pt-2 pb-2">
              <div class="col-8 float-left px-0 py-2">
                <p>NCB Protector</p>
              </div>
              <div class="col-4 float-right">
                <float-label>
                  <input type="text" class="style-box">
                </float-label>
              </div>
            </div>
            <div class="col-12 row bg-color pt-2 pb-2 mb-2">
              <div class="col-8 float-left px-0 py-2">
                <p>Tier Safe Guard</p>
              </div>
              <div class="col-4 float-right">
                <float-label>
                  <input type="text" class="style-box">
                </float-label>
              </div>
            </div>
          </div>
          <div class="border-divison ml-3">
            <div class="style-border mt-1"/>
          </div>
          <div class="col-12">
            <div class="modal-footer border-0 float-right">
              <button
                id="cover_apply_disc_modal_renew"
                type="button"
                class="btn bgc-btn-primary button-add"
                data-dismiss="modal"
              >Apply</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
export default {
  name: "CoverLevelDiscountModal",
  components: {
    FloatLabel
  }
};
</script>
<style scoped>
.border-divison {
  margin-right: 44px;
}
.style-border {
  border-bottom: 1px solid #c7c7c7;
}

.button-add {
  width: 130px;
}

input[type="text"].style-box {
  line-height: 6px;
  min-height: 33px;
}

.bg-color {
  background-color: rgb(0, 0, 0, 0.05);
}
</style>